import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { NEWS_MAIN_PAGE_PATH } from "utils/constants/paths";

const NewsMainPage = Loadable(React.lazy(() => import("./View")));

export const NewsMainPageRoute: IRouteItem = {
  path: NEWS_MAIN_PAGE_PATH,
  element: React.createElement(NewsMainPage),
  name: "News Main Page",
};
